import { createStandardAction } from 'typesafe-actions';

import { MessageStore } from '../reducers/createMessageReducer';

const showMessage = createStandardAction('@lib/showMessage')<MessageStore['message'], MessageStore['variant']>();

export default showMessage;
